import { render } from "./HelperCarregant.vue?vue&type=template&id=4ef79b96"
import script from "./HelperCarregant.vue?vue&type=script&lang=js"
export * from "./HelperCarregant.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__